export const LOADING_TRAVELERS = "Fetching travelers";
export const VALIDATING_TRAVELERS = "Validating travelers";
export const LOADING_GENERIC = "Loading";
export const CART_UPDATE_TEXT = "Fetching latest price";
